// extracted by mini-css-extract-plugin
module.exports = {"andMoreAssetLabel":"liXl71as"};